export const SET_PROJECT = 'project/set'

export const setProject = (project) => ({
  type: SET_PROJECT,
  project,
})
